import React from 'react';
import { useTranslation } from 'react-i18next';
import { changelog_en } from 'constants/changelog_en';
import { changelog_es } from 'constants/changelog_es';
import { Changelog as ChangelogComponent } from '@sidraaabdullah/test-shared-library';
import { H5, H6, P } from 'components/reusable-css';
const translations = {
  en: changelog_en,
  es: changelog_es,
};

const Changelog = () => {
  const { i18n } = useTranslation();

  return <ChangelogComponent Heading5={H5} Heading6={H6} translationsArr={translations[i18n.language]} Paragraph={P} />;
};

export default Changelog;
